import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const medium = defineConnector({
  identifier: "medium",
  name: "Medium",
  tagLine: "Online publishing platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.medium\\.com/.*",
  auth: (app) => bearerAuth(app.secret.integrationToken),
  steps: [
    {
      title: "Get your integration token",
      items: [
        {
          kind: "markdown",
          content:
            "In Medium, go to **Settings → Security and apps → Integration tokens** and generate a new token.",
        },
        {
          kind: "input",
          label: "Integration token",
          required: true,
          target: { kind: "secrets", field: "integrationToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.medium.com/v1/me",
  },
});
